import { dateTimeFormat } from '@/utility/utility_functions'

class CaseLog {
  constructor (timestamp, changedBy, content) {
    this.timestamp = timestamp
    this.changedBy = changedBy
    this.content = content
  }

  static asCaseLogs (json) {
    return json.map(jsonCaseLog => {
      return CaseLog.asCaseLog(jsonCaseLog)
    })
  }

  static asCaseLog (json) {
    return new CaseLog(
      json.timestamp ? dateTimeFormat(json.timestamp, 'YYYY-MM-DD HH:mm') : '',
      json.changed_by,
      json.content
    )
  }
}

export {
  CaseLog
}
